/**
 * Created by vallefor on 17.01.18.
 */
import cloneDeep from 'lodash/cloneDeep';
import pickBy from 'lodash/pickBy';
import merge from 'lodash/merge';
import identity from 'lodash/identity';

export default function (me,code='main') {
  if(me===null) {
    me={
      state:{},
      setState:()=>{}
    };
  }
  const varsStore = {
    curVars: JSON.parse(localStorage.getItem(`myanimeshelf_${code}`)?localStorage.getItem(`myanimeshelf_${code}`):'{}'),
    setVars: (vars)=> {
      let cloned=cloneDeep(vars);
      let newVars={};
      for(let i in cloned) {
        if(typeof cloned[i] === 'object') {
          cloned[i] = pickBy(cloned[i], identity)
          if(Object.keys(cloned[i]).length===0) {
            delete cloned[i];
          }
        } else {
          if(typeof cloned[i] === 'undefined') {
            delete cloned[i];
          }
        }
      }
      cloned=pickBy(cloned,identity);
      me.setState({ [code]:cloned });
      localStorage.setItem(`myanimeshelf_${code}`,JSON.stringify(cloned));
    },
    getVars: ()=> {
      if(me.state[code]) {
        return me.state[code];
      } else {
        return JSON.parse(localStorage.getItem(`myanimeshelf_${code}`)?localStorage.getItem(`myanimeshelf_${code}`):'{}');
      }
    },
    appendVars: (varsInput)=> {
      let vars = cloneDeep(varsInput);
      let ob = merge(varsStore.getVars(), vars);
      ob = pickBy(ob, identity);
      localStorage.setItem(`myanimeshelf_${code}`,JSON.stringify(ob));
      me.setState({ [code]:ob });
    },
    valueLink: (codeToSave)=>{
      return {
        value:me.state[code][codeToSave],
        requestChange:(newValue)=>{
          let cloned=me.state[code];
          cloned[codeToSave]=newValue;
          me.setState({ [code]:cloned });
          localStorage.setItem(`myanimeshelf_${code}`,JSON.stringify(cloned));
        }
      }
    }
  };
  return varsStore;
}
